/**
 * send event to Criteo for retargeting
 * @param event {object} event
 */
import $ from 'jquery';

export const getRealtorIds = realtorItemSelector => {
    const realtorIds = [];
    $(realtorItemSelector)
        .slice(0, 5)
        .each((i, elem) => {
            realtorIds.push($(elem).attr('data-realtor-id'));
        });

    return realtorIds;
};

export const computeCriteoAType = realtorItemSelector => {
    const realtorTypes = new Set();
    $(realtorItemSelector)
        .slice(0, 5)
        .each((i, item) => {
            realtorTypes.add($(item).attr('data-realtor-type'));
        });

    return realtorTypes.size > 1 ? 'professional' : [...realtorTypes][0];
};
